import { ReactNode, useEffect, useState } from 'react';

import bgDurante from '@/assets/tournaments/bg_ml-durante.png';
import bgFinal from '@/assets/tournaments/bg_ml-final.png';
import bgPrize from '@/assets/tournaments/bg_ml-prize.png';
import bgPrizeDkp from '@/assets/tournaments/bg_ml-prize_dkp.png';
import { useIsDesktop } from '@/hooks/useIsDesktop';
import { EnumCoverMinileagues } from '@/types/minileagues';

const bgFinalWinner = bgFinal;

const bgFinalDkp = bgPrizeDkp;
const bgFinalWinnerDkp = bgPrizeDkp;

interface ContextData {
  bg: string;
  bgDesktop?: string;
  title: ReactNode;
  titleMob?: ReactNode;
  paddingRight?: string; // "40%" | "30%" | undefined;
}

const DATA_CONTEXT = (
  position?: number,
  prize?: string
): Partial<Record<EnumCoverMinileagues, ContextData>> => ({
  [EnumCoverMinileagues.Prize]: {
    bg: bgPrize,
    bgDesktop: bgPrizeDkp,
    title: (
      <>
        <span className="lg:hidden text-3xl/7 font-normal block">
          MINILIGAS
        </span>
        <span className="text-[17px]/4 lg:text-base block">
          ¡Hay premios en efectivo
          <br /> para los 5 mejores!
        </span>
      </>
    ),
  },
  /* [EnumCoverMinileagues.Consult]: {
    bg: bgDurante,
    bgDesktop: bgPrizeDkp,
    title: (
      <>
        Consultá cómo terminaste
        <br /> en tu Miniliga
      </>
    ),
  }, */
  [EnumCoverMinileagues.PassFinal]: {
    bg: bgDurante,
    bgDesktop: bgPrizeDkp,
    title: (
      <>
        Ganá tu pase a la Final y<br />
        competí por premios en efectivo
      </>
    ),
  },
  [EnumCoverMinileagues.FinalEnd]: {
    bg: bgDurante,
    bgDesktop: bgPrizeDkp,
    title: (
      <>
        CONSULTÁ CÓMO TERMINASTE <br /> EN TU MINILIGA
      </>
    ),
  },
  [EnumCoverMinileagues.NoParticipate]: {
    bg: bgDurante,
    title: '',
  },
  [EnumCoverMinileagues.NotClassified]: {
    bg: '',
    title: '',
  },
  [EnumCoverMinileagues.NotWinner]: {
    bg: '',
    title: '',
  },
  [EnumCoverMinileagues.Classified]: {
    bg: '',
    title: '',
  },
  [EnumCoverMinileagues.Winner]: {
    bg: '',
    title: '',
  },
  [EnumCoverMinileagues.InProgress]: {
    bg: bgDurante,
    title: 'Miniligas',
  },
  [EnumCoverMinileagues.FinalClassified]: {
    bg: bgFinal,
    bgDesktop: bgFinalDkp,
    title:
      'ESTÁS EN LA FINAL. ¡MEJORÁ TU EQUIPO! PODÉS SER UNO DE LOS 5 GANADORES.',
  },
  [EnumCoverMinileagues.FinalPlayerNotClassified]: {
    bg: bgFinal,
    bgDesktop: bgFinalDkp,
    title: 'NO CLASIFICASTE A LA FINAL. ¡CONOCÉ MUY PRONTO A LOS GANADORES!',
  },
  [EnumCoverMinileagues.FinalPlayerNotParticipating]: {
    bg: bgFinal,
    bgDesktop: bgFinalDkp,
    title:
      'NO PARTICIPASTE DE LAS MINILIGAS. ¡CONOCÉ MUY PRONTO A LOS GANADORES!',
  },
  /* [EnumCoverMinileagues.FinalWinner]: {
    bg: bgFinal,
    bgDesktop: bgFinalDkp,
    title: '¡FELICITACIONES! ERES UNO DE LOS GANADORES DE LA FINAL.',
  }, */
  [EnumCoverMinileagues.FirstMale]: {
    bg: bgFinalWinner,
    bgDesktop: bgFinalWinnerDkp,
    title: (
      <>
        ¡FELICITACIONES! SOS EL CAMPEÓN DE MINILIGAS.
        <br />
        ¡GANASTE ${prize}!
      </>
    ),
  },
  [EnumCoverMinileagues.SecondMale]: {
    bg: bgFinalWinner,
    bgDesktop: bgFinalWinnerDkp,
    title: (
      <>
        ¡FELICITACIONES! SALISTE SEGUNDO EN LA FINAL DE MINILIGAS.
        <br />
        GANASTE ${prize}
      </>
    ),
  },
  [EnumCoverMinileagues.ThirdMale]: {
    bg: bgFinal,
    bgDesktop: bgFinalDkp,
    title: (
      <>
        ¡FELICITACIONES! SALISTE TERCERO EN LA FINAL DE MINILIGAS.
        <br />
        GANASTE ${prize}
      </>
    ),
  },
  [EnumCoverMinileagues.FourthMale]: {
    bg: bgFinal,
    bgDesktop: bgFinalDkp,
    title: (
      <>
        ¡FELICITACIONES! SALISTE CUARTO EN LA FINAL DE MINILIGAS.
        <br />
        GANASTE ${prize}
      </>
    ),
  },
  [EnumCoverMinileagues.FifthMale]: {
    bg: bgFinal,
    bgDesktop: bgFinalDkp,
    title: (
      <>
        ¡FELICITACIONES! SALISTE QUINTO EN LA FINAL DE MINILIGAS.
        <br />
        GANASTE ${prize}
      </>
    ),
  },
  [EnumCoverMinileagues.FirstFemale]: {
    bg: bgFinalWinner,
    bgDesktop: bgFinalWinnerDkp,
    title: (
      <>
        ¡FELICITACIONES! SOS LA CAMPEONA DE MINILIGAS.
        <br />
        ¡GANASTE ${prize}!
      </>
    ),
  },
  [EnumCoverMinileagues.SecondFemale]: {
    bg: bgFinalWinner,
    bgDesktop: bgFinalWinnerDkp,
    title: (
      <>
        ¡FELICITACIONES! SALISTE SEGUNDA EN LA FINAL DE MINILIGAS.
        <br />
        GANASTE ${prize}
      </>
    ),
  },
  [EnumCoverMinileagues.ThirdFemale]: {
    bg: bgFinal,
    bgDesktop: bgFinalDkp,
    title: (
      <>
        ¡FELICITACIONES! SALISTE TERCERA EN LA FINAL DE MINILIGAS.
        <br />
        GANASTE ${prize}
      </>
    ),
  },
  [EnumCoverMinileagues.FourthFemale]: {
    bg: bgFinal,
    bgDesktop: bgFinalDkp,
    title: (
      <>
        ¡FELICITACIONES! SALISTE CUARTA EN LA FINAL DE MINILIGAS.
        <br />
        GANASTE ${prize}
      </>
    ),
  },
  [EnumCoverMinileagues.FifthFemale]: {
    bg: bgFinal,
    bgDesktop: bgFinalDkp,
    title: (
      <>
        ¡FELICITACIONES! SALISTE QUINTA EN LA FINAL DE MINILIGAS.
        <br />
        GANASTE ${prize}
      </>
    ),
  },
  [EnumCoverMinileagues.NoTop5]: {
    bg: bgFinal,
    bgDesktop: bgFinalDkp, // /* LAMENTABLEMENTE NO ESTÁS ENTRE LOS GANADORES. */
    title: (
      <>
        QUEDASTE EN EL PUESTO {position}.
        <br />
        ¡TE ESPERAMOS EN LA PRÓXIMA EDICIÓN!
      </>
    ),
  },
  [EnumCoverMinileagues.NotParticipatedOrNotClassified]: {
    bg: bgFinal,
    bgDesktop: bgFinalDkp,
    title: (
      <div className="max-w-[160px] lg:max-w-none">
        ESTOS FUERON LOS MEJORES DE LA FINAL.
        <br />
        ¡TE ESPERAMOS EN LA PRÓXIMA EDICIÓN!
      </div>
    ),
  },
});

interface Props {
  context?: EnumCoverMinileagues;
  position?: number;
  prize?: string;
}

export const useBackgroundByContext = ({
  context = EnumCoverMinileagues.Prize,
  position,
  prize,
}: Props) => {
  const [state, setState] = useState<ContextData | null>(null);
  const { isMobile } = useIsDesktop();

  useEffect(() => {
    const data = DATA_CONTEXT(position, prize)[context];
    if (data) {
      setState(data);
    } else {
      setState(null);
    }
  }, [context]);

  if (!state) {
    return null;
  }

  if (isMobile) {
    return { src: state.bg, title: state.title };
  }

  return { src: state.bgDesktop, title: state.title };
};
